/**
 * Optimized FontAwesome icon configuration
 * Only imports the icons actually used in the package
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import { fawsb, fas } from '@awesome.me/kit-5b19ea3ded/icons';

library.add(fawsb, fas);
